import React from "react";
import { Formik, Form } from "formik";
import { Box, Button, Typography, TextField, Grid } from "@mui/material";
import * as Yup from "yup"; // For form validation
import "./physical-and-emotional.css";

// Validation schema using Yup
const validationSchema = Yup.object({
  physicalEducationalNeeds: Yup.string().required("This field is required"),
  physicalHistory: Yup.string().required("This field is required"),
  physicalContingencyPlan: Yup.string().required("This field is required"),
  physicalSupportOffered: Yup.string().required("This field is required"),
  physicalRequiredActions: Yup.string().required("This field is required"),
});

const PhysicalAndEmotional = ({ updateFormData, nextStep, prevStep }) => {
  const initialValues = {
    physicalEducationalNeeds: "",
    physicalHistory: "",
    physicalContingencyPlan: "",
    physicalSupportOffered: "",
    physicalRequiredActions: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        updateFormData({ physicalAndEmotionalInfo: values });
        nextStep(); // Move to next form
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <Form onSubmit={handleSubmit} className='form-container'>
          <Typography variant='h6' sx={{ fontWeight: "bold" }} align='left'>
            Physical And Emotional Health Needs
          </Typography>
          <Typography variant='body2' gutterBottom mt={1}>
            Explain the reasons why this young person is being considered for placement.
          </Typography>
          {/* How will educational needs be met? */}
          <Box mt={3}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              How will the health needs be met?
            </Typography>

            <TextField
              id='physicalEducationalNeeds'
              name='physicalEducationalNeeds'
              fullWidth
              multiline
              rows={4}
              value={values.physicalEducationalNeeds}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.physicalEducationalNeeds && errors.physicalEducationalNeeds)}
              helperText={
                touched.physicalEducationalNeeds && errors.physicalEducationalNeeds
                  ? errors.physicalEducationalNeeds
                  : ""
              }
              variant='outlined'
            />
          </Box>

          {/* History*/}
          <Box mt={2}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              History
            </Typography>
            <Typography variant='body2' gutterBottom mt={1}>
              Detail physical and mental health.
            </Typography>
            <TextField
              id='physicalHistory'
              name='physicalHistory'
              fullWidth
              multiline
              rows={4}
              value={values.physicalHistory}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.physicalHistory && errors.physicalHistory)}
              helperText={touched.physicalHistory && errors.physicalHistory ? errors.physicalHistory : ""}
              variant='outlined'
            />
          </Box>

          {/* Contingency plan/additional resources */}
          <Box mt={2}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              Contingency plan/additional resources
            </Typography>
            <Typography variant='body2' gutterBottom mt={1}>
              Detail ongoing support as well as services we will register ie localCAMHS and give a time <br />
              frame
            </Typography>
            <TextField
              id='physicalContingencyPlan'
              name='physicalContingencyPlan'
              fullWidth
              multiline
              rows={4}
              value={values.physicalContingencyPlan}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.physicalContingencyPlan && errors.physicalContingencyPlan)}
              helperText={
                touched.physicalContingencyPlan && errors.physicalContingencyPlan ? errors.physicalContingencyPlan : ""
              }
              variant='outlined'
            />
          </Box>

          {/* Support offered by all parties */}
          <Box mt={2}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              Support offered by all parties
            </Typography>

            <TextField
              id='physicalSupportOffered'
              name='physicalSupportOffered'
              fullWidth
              multiline
              rows={4}
              value={values.physicalSupportOffered}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.physicalSupportOffered && errors.physicalSupportOffered)}
              helperText={
                touched.physicalSupportOffered && errors.physicalSupportOffered ? errors.physicalSupportOffered : ""
              }
              variant='outlined'
            />
          </Box>

          {/* Required actions */}
          <Box mt={2}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              Required actions
            </Typography>
            <Typography variant='body2' gutterBottom mt={1}>
              Reiterate what we will do as a service to action the support ie email CAMHS etc.Include <br />
              who is responsible and desired completion date.
            </Typography>
            <TextField
              id='physicalRequiredActions'
              name='physicalRequiredActions'
              fullWidth
              multiline
              rows={4}
              value={values.physicalRequiredActions}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.physicalRequiredActions && errors.physicalRequiredActions)}
              helperText={
                touched.physicalRequiredActions && errors.physicalRequiredActions ? errors.physicalRequiredActions : ""
              }
              variant='outlined'
            />
          </Box>

          <Grid container justifyContent='space-between' alignItems='center' mt={2}>
            <Grid item>
              <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                Previous
              </Button>
            </Grid>
            <Grid item>
              <Button type='submit' variant='contained' color='primary'>
                Next
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default PhysicalAndEmotional;
